export default __webpack_public_path__ + "static/media/Background_00221.b463256b.png";